module.exports = "/images/MockupConseil.png?510ca1a39a2f9361625574b62c90fe2d";